function formatPrice(cents) {
  const str = Math.round(cents).toString().padStart(3, '0');
  return str.slice(0, -2) + ',' + str.slice(-2);
}

function vendorSlug(vendor) {
  return vendor.toLowerCase().replace(/ /g, '-').replace(/[+'.&]/g, '');
}

async function addToCartProductCard(button) {
  const variantId = button.dataset.variantId;
  const cartDrawer = document.querySelector('cart-drawer');

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  if (cartDrawer) {
    formData.append('sections', cartDrawer.getSectionsToRender().map((s) => s.id));
    formData.append('sections_url', window.location.pathname);
    cartDrawer.setActiveElement(document.activeElement);
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: formData,
  });
  const data = await response.json();

  if (cartDrawer && data.sections) cartDrawer.renderContents(data);

  button.removeAttribute('aria-disabled');
  button.classList.remove('loading');
}

function buildProductCard(product, wrapperClass, imageClass = 'min-h-[290px] max-h-[290px]') {
  const promoHtml =
    product.promo || product.variant_promo
      ? `<div class="promo"><span class="z-[5] text-[14px] relative rounded-full bg-[var(--abRed)] kal text-white py-0.5 px-4 mt-1">${product.promo || product.variant_promo}</span></div>`
      : '';

  const priceHtml = product.show_strikethrough
    ? `<span class="!text-[#3E3A3A80] text-[13px] line-through">${formatPrice(product.strikethrough_price)}</span>
       <span class="font-semibold text-[14px]">${formatPrice(product.display_price)}</span>`
    : `<span class="font-semibold text-[14px]">${formatPrice(product.display_price)}</span>`;

  const stockHtml = product.available
    ? `<span class="voorraad clear-both flex text-[#15803D] text-[12px] md:text-[14px] font-medium block py-1">
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="float-left text-[#15803D] mr-1 w-5 h-5">
           <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"/>
         </svg> Op voorraad</span>`
    : `<span class="clear-both voorraad text-[12px] md:text-[14px] font-medium block py-1 !text-[var(--abRed)]">Niet op voorraad</span>`;

  let variantsHtml = '';
  if (product.color_variants) {
    variantsHtml =
      `<ul class="flex text-sm flex-row text-(--abBlack)">` +
      product.color_variants
        .map(
          (v) =>
            `<a aria-label="Kies ${v.title}" class="productsColor" href="${v.url}"><li style="background:${v.kleur};" class="rounded-full mr-2.5 pr-2.5 h-6 w-6 border-2"></li></a>`
        )
        .join('') +
      `</ul>`;
  } else if (product.diverse_variants) {
    variantsHtml = `<ul class="flex text-sm flex-row text-(--abBlack)"><li class="pr-2.5 mr-2.5">Diverse varianten</li></ul>`;
  } else if (product.variant_list) {
    variantsHtml =
      `<ul class="flex text-sm flex-row text-(--abBlack)">` +
      product.variant_list
        .map(
          (v) =>
            `<li class="pr-2.5 mr-2.5 border-r"><a href="${v.url}">${v.title.includes('Default') ? 'Standaard' : v.title}</a></li>`
        )
        .join('') +
      `</ul>`;
  }

  const cartButtonHtml =
    product.available && product.variant_id
      ? `<button
           type="button"
           aria-label="Voeg ${product.title} toe aan winkelwagen"
           class="cursor-pointer w-[31px] z-10 flex cartButton h-[31px] absolute right-[5px] bottom-[5px]"
           aria-haspopup="dialog"
           data-variant-id="${product.variant_id}"
           onclick="addToCartProductCard(this)"
         >
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
             <path d="M2.25 2.25a.75.75 0 000 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 00-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 000-1.5H5.378A2.25 2.25 0 017.5 15h11.218a.75.75 0 00.674-.421 60.358 60.358 0 002.96-7.228.75.75 0 00-.525-.965A60.864 60.864 0 005.68 4.509l-.232-.867A1.875 1.875 0 003.636 2.25H2.25zM3.75 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16.5 20.25a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"/>
           </svg>
         </button>`
      : '';

  const productDiv = document.createElement('div');
  productDiv.className = wrapperClass;
  productDiv.innerHTML = `
    ${promoHtml}
    <a href="${product.url}">
      <div class="productImage flex rounded-[10px] mb-1 ${imageClass} items-center justify-center border border-[#f2f2f2ad]">
        <img alt="${product.title}" loading="lazy" src="${product.featured_image || ''}" style="max-width:100%;max-height:100%;object-fit:contain;">
      </div>
    </a>
    <div class="productInfo relative w-[95%]">
      <a class="line-clamp-1 w-full text-[13px] md:text-sm pt-1" href="/collections/${vendorSlug(product.vendor)}">${product.vendor}</a>
      <a href="${product.url}" class="text-[14px] min-h-[45px] productsTitleSpan line-clamp-2 text-[var(--abBlack)] volk font-bold">${product.title}</a>
      <div class="flex items-center gap-2">${priceHtml}</div>
      ${stockHtml}
      ${cartButtonHtml}
      <div class="min-h-[25px] listVariants variants flex items-end">${variantsHtml}</div>
    </div>
  `;

  return productDiv;
}
